<template>
  <div>
    <h1 class="no-file-selected" v-if="!isAllowedToAddFile && !selectedFile">
      No File Selected
    </h1>
    <div v-show="isAllowedToAddFile && !value">
      <input
        type="file"
        ref="file"
        v-show="false"
        :accept="accpetedFileTypes"
        @change="onFileSelect($event)"
      />
      <input
        type="button"
        class="file-selected"
        @click="$refs.file.click()"
        value="+"
      />
    </div>
    <div class="dropped-file-wrap" v-if="value">
      <div class="dropped-file-name">
        <div class="dropped-file-content">
          <div class="name">
            <span> {{ value.name }} </span>
            <!-- <span> {{ fileName }}</span> -->
          </div>
          <div
            class="file-picker-icons"
            v-if="isActionsButtonEnable && !isAddOnly"
          >
            <ul>
              <li>
                <i class="fa fa-edit" @click="onEditFileButtonClick()"></i>
              </li>
              <li><i class="fa fa-trash" @click="onDeleteFileButton"></i></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedFile: null,
    };
  },
  props: {
    isAllowedToAddFile: {
      type: Boolean,
      default: true,
    },
    isActionsButtonEnable: {
      type: Boolean,
      default: true,
    },
    accpetedFileTypes: {
      type: String,
      default: '*',
    },
    isAddOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onFileSelect(event) {
      if (!event.target.files[0]) return;
      this.selectedFile = event.target.files[0];
      this.$emit('onFileSelected', event.target.files[0]);
    },
    onDeleteFileButton(event, canEmit = true) {
      this.selectedFile = null;
      if (canEmit) this.$emit('onFileDelete');
    },

    setFile(file) {
      this.selectedFile = file;
    },
    onEditFileButtonClick() {
      this.$refs.file.click();
    },
  },
  mounted() {
    if (this.value && this.value.name) this.selectedFile = this.value;
  },
};
</script>
<style scoped>
.no-file-selected {
  font-size: 20px;
  border: 1px solid #dee3e9;
  box-sizing: border-box;
  padding: 16px 0;
  width: 100%;
  margin: 0;
  border-radius: 2px;
}
.file-selected {
  background-color: #cccccc;
  border: 1px solid #cccccc;
  color: #fff;
  font-size: 40px;
  padding: 10px;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: block;
  height: auto;
  cursor: pointer;
  line-height: 20px;
}

.dropped-file-wrap {
  box-sizing: border-box;
  display: flex;
  margin: 0 0; /*For New editMode UI*/
  flex-wrap: wrap;
}

.dropped-file-wrap .dropped-file-name {
  width: 100%;
  -webkit-box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: 4px;
  margin: 0 0px;
  padding: 10px 10px;
  box-sizing: border-box;
}
.no-file-selected {
  position: relative;
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: #464d5d;
  padding: 7px 0;
}

.dropped-file-content {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropped-file-content ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.dropped-file-content ul li {
  margin-left: 8px;
}
.dropped-file-content .name {
  font-size: 13px;
  color: #464d5d;
}
.file-picker-icons i {
  cursor: pointer;
}
</style>
